import { Layout, Drawer } from "antd";
import { FC, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth, useApp } from "~/store";
import { StaffHeader } from "./header";
import { StaffSidebar } from "./sidebar";
import PageMeta from "~/components/common/meta";

type Props = {};

const SLayout: FC<Props> = () => {
  const { collapsed, setCollapsed } = useApp();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  
  return (
    <Layout className="min-h-screen">
      <StaffHeader />
      
      {/* Main Content Area */}
      <Layout style={{ position: 'relative' }}>
        {/* Desktop Sidebar - Fixed Position */}
        <div className="hidden lg:block">
          <div
            className={`fixed top-16 left-0 h-[calc(100vh-4rem)] bg-white shadow-lg transition-all duration-300 ease-in-out z-10 ${
              sidebarCollapsed ? 'w-16' : 'w-64'
            }`}
            style={{
              borderRight: '1px solid #f0f0f0',
            }}
          >
            <StaffSidebar 
              isCollapsed={sidebarCollapsed} 
              onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
            />
          </div>
        </div>

        {/* Mobile Sidebar Drawer */}
        <Drawer
          placement="left"
          onClose={() => setCollapsed(false)}
          open={collapsed}
          className="lg:hidden"
          width="280px"
          classNames={{
            body: "p-0",
          }}
          styles={{
            header: { display: 'none' },
          }}
        >
          <StaffSidebar isCollapsed={false} onToggleCollapse={() => {}} />
        </Drawer>

        {/* Main Content */}
        <div
          className={`min-h-[calc(100vh-4rem)] transition-all duration-300 ease-in-out ${
            sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'
          } lg:ml-0`}
          style={{
            marginLeft: window.innerWidth >= 1024 ? (sidebarCollapsed ? '64px' : '256px') : '0',
          }}
        >
          <div className="p-3 sm:p-4 lg:p-6">
            <div className="bg-white rounded-lg shadow-sm">
              <div className="p-3 sm:p-4 lg:p-6">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </Layout>
  );
};

export const StaffLayout: FC = () => {
  const { isAuth } = useAuth();

  if (!isAuth) {
    return <Navigate to="/login" />;
  }
  return (
    <>
      <PageMeta
        title="Staff Dashboard | Art Handler"
        description="Staff Dashboard | Art Handler"
      />
      <SLayout />
    </>
  );
};
